// ─────────────────────────────────────────────────────────────────────
// BarreChiffrage — « CHIFFRER TOUT LE DEVIS »
//
// Le geste par PIÈCE vit sous sa consigne, contre le dessin : on écrit
// comment on ferait, puis on chiffre. Celui-ci est pour l'autre cas —
// vingt-deux pages sur lesquelles on n'a rien de particulier à dire.
//
// Il n'apparaît que s'il reste quelque chose à chiffrer : un bouton qui
// ne ferait rien inviterait au clic qui ne fait rien.
// ─────────────────────────────────────────────────────────────────────

import Button from '../../ui/Button.jsx';

export function BarreChiffrage({ aChiffrer, occupe, onChiffrer }) {
  if (!aChiffrer) return null;
  return (
    <div className="row row--between devis__chiffrage">
      <span className="field__hint">
        <strong>{aChiffrer} pièce(s) à chiffrer.</strong> Écrivez d’abord comment vous
        usineriez celles qui le méritent — la consigne oriente la gamme dès le premier
        chiffrage — puis lancez le reste d’un coup.
      </span>
      <Button variant="primary" disabled={occupe} onClick={onChiffrer}>
        {occupe ? 'Chiffrage lancé…' : 'Chiffrer tout le devis'}
      </Button>
    </div>
  );
}

export default BarreChiffrage;
